import { useForm } from 'react-final-form';
import { ChangeEvent } from 'react';
import { validateNumField } from '../utils/helpers/validateItemForm';

export const useTextFieldChange = (formValues: Record<string, string>) => {
  const { change } = useForm();

  return (
    e: ChangeEvent<HTMLInputElement>,
    name: string,
    isNum: boolean,
    isFloat: boolean
  ) => {
    const { value } = e.target;

    if (isNum) {
      const { isValid, val } = validateNumField(isFloat, { value });
      if (isValid) change(formValues[name], val);
      else e.preventDefault();
    } else change(formValues[name], value);
  };
};
